import React, { useEffect } from "react";
import { RiExternalLinkLine } from "react-icons/ri";
import explorationsData from "../data/explorations";
import "aos/dist/aos.css";
import "../index.css";

const ITEM_WIDTH = 400; // Set a constant width for each element

export default function Certifications() {
  useEffect(() => {
    const interval = setInterval(() => {
      const scrollContainer = document.querySelector(".scroll-container");
      if (scrollContainer) {
        scrollContainer.scrollBy({
          left: ITEM_WIDTH,
          behavior: "smooth",
        });
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0;
        }
      }
    }, 1500); // Increased scrolling speed

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="mt-10 sm:ml-20 m-4 mb-20 relative">
        <h1
          className="text-2xl mt-20 mb-10"
          data-aos="zoom-in-right"
          data-aos-duration="2000"
          data-aos-easing="ease-in-out"
        >
          Explorations
        </h1>
        <div className="scroll-container mt-6 mr-20 overflow-hidden relative">
          <div className="scroll-content flex">
            {explorationsData
              .concat(explorationsData)
              .map((certification, index) => (
                <div
                  key={index}
                  className="scroll-item inline-block"
                  style={{ width: ITEM_WIDTH }}
                >
                  <div className="bg-gray-800 rounded-lg p-4 shadow-md">
                    <div className="w-full h-40 mb-4 overflow-hidden rounded-lg">
                      <img
                        src={certification.image}
                        alt={certification.title}
                        className="object-cover w-full h-full object-top"
                      />
                    </div>
                    <h2 className="text-xl font-bold mb-2">
                      {certification.title}
                    </h2>
                    <a
                      href={certification.view}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-gray-300 flex items-center"
                    >
                      View project <RiExternalLinkLine className="ml-1" />
                    </a>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <hr className="border-gray-600 mt-40 mb-5" />
    </>
  );
}
